<template>
  <div class="event-banner">
    <div
      v-for="event in eventBannerList"
      :key="event.eventid"
      class="detail-event"
    >
      <div class="banner-type">
        <a
          @click.prevent="goToEventDetailPage(event)"
          href="javascript:void(0)"
          :title="`${event.eventtitle} 상세로 이동`"
        >
          <img :src="getEventImage(event.bannerimage)" :alt="event.eventtitle" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { resizeThumbnail } from '@/common/utils/image'

export default {
  name: 'EventBanner',
  props: {
    eventBannerList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getEventImage (img) {
      if (img) {
        return resizeThumbnail(img, { width: 0, height: 0, option: 20, quality: 80 })
      }
      return ''
    },
    goToEventDetailPage (event = {}) {
      const eventId = event?.eventid ?? ''

      this.$router.push({
        name: 'event_view',
        query: {
          eventId: eventId
        }
      })
    }
  }
}
</script>
